import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { AppContext } from '@/contexts/AppContext/AppContextProvider.tsx';

export const ModeratorRoutes = () => {
	const { admin, moderator } = useContext(AppContext);

	if (!admin && !moderator) {
		return <Navigate to={'/'} replace />;
	}

	return <Outlet />;
};
